import React, { useState, useEffect, useCallback } from "react";
import Sidebar from "../../components/sidebar";
import Card from "react-bootstrap/Card";
import { Collapse, Button, Row, Col } from "react-bootstrap";
import axios from 'axios';
import SinPermisos from "./../../components/sinpermisos";
import debounce from 'lodash.debounce';

const urlPost = "https://api.mrcirp.com/public/usuarios";
const verificarusuario = "https://api.mrcirp.com/public/usuarioexiste";

const Referidos = () => {

  //////////////Datos de Usuario Logueado/////////////////////////
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem('loginUser')
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON)
      setUsers(user);
    }
  }, []);



  ///////////////Insertar Datos//////////////////////////////////
  const [nuevoUsuario, setNuevoUsuario] = useState({
    nombrecampana:'',
    nombre: '',
    descripcion: '',
    urlVideo: '',
    urlVideoProducto1: '',
    urlVideoProducto2: '',
    urlVideoProducto3: '',
    urlNegocio1: '',
    urlNegocio2: '',
    urlNegocio3: '',
    urlComoUnirseCliente: '',
    urlComoAfiliarse: '',
    urlBotonProducto: '', // Nuevo campo
    urlBotonNegocio: '' // Nuevo campo
  });

  const [mensajeExito, setMensajeExito] = useState('');
  const [mensajeVerificacion, setMensajeVerificacion] = useState('');
  const [colorVerificacion, setColorVerificacion] = useState('');
  
  // Estados para dropdowns
  const [openBasico, setOpenBasico] = useState(true);
  const [openVideos, setOpenVideos] = useState(false);
  const [openRevelacion, setOpenRevelacion] = useState(false);
  const [openExito, setOpenExito] = useState(false);

  const verificarNombre = useCallback(debounce(async (nombre) => {
    try {
      console.log(`${verificarusuario}/${nombre}`);
      const response = await axios.get(`${verificarusuario}/${nombre}`);
      if (response.data === true) {
        setMensajeVerificacion('Enlace existente');
        setColorVerificacion('red');
      } else {
        setMensajeVerificacion('Enlace disponible');
        setColorVerificacion('green');
      }
    } catch (err) {
      console.error(err);
    }
  }, 500), []);

  const handleChangeInsertar = e => {
    const { name, value } = e.target;
    setNuevoUsuario(prevState => ({
      ...prevState,
      [name]: value
    }));

    if (name === 'nombre') {
      verificarNombre(value);
    }
  }

  const peticionPost = async () => {
    try {
      const datosCompletos = {
        ...nuevoUsuario,
        adminId: users.id,
        adminNombre: users.nombreuser
      };
      console.log(datosCompletos);
      const response = await axios.post(urlPost, datosCompletos);
      console.log(response.data);
      setMensajeExito('Usuario registrado con éxito');
      setNuevoUsuario({
        nombrecampana:'',
        nombre: '',
        descripcion: '',
        urlVideo: '',
        urlVideoProducto1: '',
        urlVideoProducto2: '',
        urlVideoProducto3: '',
        urlNegocio1: '',
        urlNegocio2: '',
        urlNegocio3: '',
        urlComoUnirseCliente: '',
        urlComoAfiliarse: '',
        urlBotonProducto: '', // Nuevo campo
        urlBotonNegocio: '' // Nuevo campo
      });
      // Manejar la respuesta si es necesario
    } catch (err) {
      console.error(err);
    }
  }

  const [Error, setError] = useState(false);

  /////////////////////////////////////////////////////////////////
  if (users.rol !== undefined) {
    if (users.rol === 'admin' || users.rol === 'cliente'){
      return (
        <div>
          <div className="Categorias">
            <Sidebar>
              <Card>
                <Card.Header className="bg-dark text-white" as="h3">
                  <div className='row'>
                    <div className='col-md-12'>
                      🎬 Campana de Video
                    </div>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Card.Title>Crear Nueva Campana de Video</Card.Title>
                  {
                    Error &&
                    <div className="alert alert-danger">
                      {<strong>Error: El nombre ya existe! intente con otro nombre.</strong>}
                    </div>
                  }
                  {mensajeExito && (
                    <div className="alert alert-success">
                      {mensajeExito}
                    </div>
                  )}
                  <p>Configura tu campana de video con todos los elementos necesarios</p>
                  <div className="form-group">
                    {/* Información Básica */}
                    <div className="mb-3">
                      <Button
                        variant="outline-primary"
                        onClick={() => setOpenBasico(!openBasico)}
                        aria-controls="basico-collapse"
                        aria-expanded={openBasico}
                        className="w-100 d-flex justify-content-between align-items-center"
                      >
                        <span>📋 Información Básica</span>
                        {openBasico ? '−' : '+'}
                      </Button>
                      <Collapse in={openBasico}>
                        <div id="basico-collapse" className="mt-3">
                          <Row>
                            <Col md={6}>
                              <label><strong>Nombre de la campana</strong></label>
                              <input
                                className="form-control mb-2"
                                type="text"
                                name="nombrecampana"
                                value={nuevoUsuario.nombrecampana}
                                onChange={handleChangeInsertar}
                                placeholder="Ej: Mi Campana 2024"
                              />
                            </Col>
                            <Col md={6}>
                              <label><strong>Enlace de la campana</strong></label>
                              <input
                                className="form-control mb-2"
                                type="text"
                                name="nombre"
                                value={nuevoUsuario.nombre}
                                onChange={handleChangeInsertar}
                                placeholder="minombre (sin espacios)"
                              />
                              <small className="text-muted">www.mrcirp.com/minombre</small>
                              <span style={{ color: colorVerificacion }}>{mensajeVerificacion}</span>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={12}>
                              <label><strong>Descripción de la campana</strong></label>
                              <textarea
                                className="form-control"
                                name="descripcion"
                                value={nuevoUsuario.descripcion}
                                onChange={handleChangeInsertar}
                                maxLength="150"
                                rows="3"
                                placeholder="Describe tu campana (máximo 150 caracteres)"
                              />
                              <small className="text-muted">{nuevoUsuario.descripcion.length}/150 caracteres</small>
                            </Col>
                          </Row>
                        </div>
                      </Collapse>
                    </div>

                    {/* Videos Principales */}
                    <div className="mb-3">
                      <Button
                        variant="outline-success"
                        onClick={() => setOpenVideos(!openVideos)}
                        aria-controls="videos-collapse"
                        aria-expanded={openVideos}
                        className="w-100 d-flex justify-content-between align-items-center"
                      >
                        <span>🎥 Videos Principales</span>
                        {openVideos ? '−' : '+'}
                      </Button>
                      <Collapse in={openVideos}>
                        <div id="videos-collapse" className="mt-3">
                          <Row>
                            <Col md={12}>
                              <label><strong>URL del video de bienvenida</strong></label>
                              <input
                                className="form-control mb-2"
                                type="text"
                                name="urlVideo"
                                value={nuevoUsuario.urlVideo}
                                onChange={handleChangeInsertar}
                                placeholder="YouTube o Vimeo URL"
                              />
                            </Col>
                          </Row>
                        </div>
                      </Collapse>
                    </div>

                    {/* Zona de Revelación */}
                    <div className="mb-3">
                      <Button
                        variant="outline-warning"
                        onClick={() => setOpenRevelacion(!openRevelacion)}
                        aria-controls="revelacion-collapse"
                        aria-expanded={openRevelacion}
                        className="w-100 d-flex justify-content-between align-items-center"
                      >
                        <span>🔍 Zona de Revelación</span>
                        {openRevelacion ? '−' : '+'}
                      </Button>
                      <Collapse in={openRevelacion}>
                        <div id="revelacion-collapse" className="mt-3">
                          <Row>
                            <Col md={6}>
                              <label><strong>URL Zona de revelación 1</strong></label>
                              <input
                                className="form-control mb-2"
                                type="text"
                                name="urlVideoProducto1"
                                value={nuevoUsuario.urlVideoProducto1}
                                onChange={handleChangeInsertar}
                                placeholder="Video URL"
                              />
                            </Col>
                            <Col md={6}>
                              <label><strong>URL Zona de revelación 2</strong></label>
                              <input
                                className="form-control mb-2"
                                type="text"
                                name="urlVideoProducto2"
                                value={nuevoUsuario.urlVideoProducto2}
                                onChange={handleChangeInsertar}
                                placeholder="Video URL"
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col md={6}>
                              <label><strong>URL Zona de revelación 3</strong></label>
                              <input
                                className="form-control mb-2"
                                type="text"
                                name="urlVideoProducto3"
                                value={nuevoUsuario.urlVideoProducto3}
                                onChange={handleChangeInsertar}
                                placeholder="Video URL"
                              />
                            </Col>
                            <Col md={6}>
                              <label><strong>URL Botón Zona de revelación</strong></label>
                              <input
                                className="form-control mb-2"
                                type="text"
                                name="urlBotonProducto"
                                value={nuevoUsuario.urlBotonProducto}
                                onChange={handleChangeInsertar}
                                placeholder="Enlace del botón"
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col md={12}>
                              <label><strong>URL Video de agradecimiento producto</strong></label>
                              <input
                                className="form-control mb-2"
                                type="text"
                                name="urlComoUnirseCliente"
                                value={nuevoUsuario.urlComoUnirseCliente}
                                onChange={handleChangeInsertar}
                                placeholder="Video de agradecimiento"
                              />
                            </Col>
                          </Row>
                        </div>
                      </Collapse>
                    </div>

                    {/* Zona de Éxito */}
                    <div className="mb-3">
                      <Button
                        variant="outline-info"
                        onClick={() => setOpenExito(!openExito)}
                        aria-controls="exito-collapse"
                        aria-expanded={openExito}
                        className="w-100 d-flex justify-content-between align-items-center"
                      >
                        <span>🏆 Zona de Éxito</span>
                        {openExito ? '−' : '+'}
                      </Button>
                      <Collapse in={openExito}>
                        <div id="exito-collapse" className="mt-3">
                          <Row>
                            <Col md={6}>
                              <label><strong>URL Zona de éxito 1</strong></label>
                              <input
                                className="form-control mb-2"
                                type="text"
                                name="urlNegocio1"
                                value={nuevoUsuario.urlNegocio1}
                                onChange={handleChangeInsertar}
                                placeholder="Video URL"
                              />
                            </Col>
                            <Col md={6}>
                              <label><strong>URL Zona de éxito 2</strong></label>
                              <input
                                className="form-control mb-2"
                                type="text"
                                name="urlNegocio2"
                                value={nuevoUsuario.urlNegocio2}
                                onChange={handleChangeInsertar}
                                placeholder="Video URL"
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col md={6}>
                              <label><strong>URL Zona de éxito 3</strong></label>
                              <input
                                className="form-control mb-2"
                                type="text"
                                name="urlNegocio3"
                                value={nuevoUsuario.urlNegocio3}
                                onChange={handleChangeInsertar}
                                placeholder="Video URL"
                              />
                            </Col>
                            <Col md={6}>
                              <label><strong>URL Botón Zona de éxito</strong></label>
                              <input
                                className="form-control mb-2"
                                type="text"
                                name="urlBotonNegocio"
                                value={nuevoUsuario.urlBotonNegocio}
                                onChange={handleChangeInsertar}
                                placeholder="Enlace del botón"
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col md={12}>
                              <label><strong>URL Video de agradecimiento negocio</strong></label>
                              <input
                                className="form-control mb-2"
                                type="text"
                                name="urlComoAfiliarse"
                                value={nuevoUsuario.urlComoAfiliarse}
                                onChange={handleChangeInsertar}
                                placeholder="Video de agradecimiento"
                              />
                            </Col>
                          </Row>
                        </div>
                      </Collapse>
                    </div>

                    {/* Botón de Registro */}
                    <div className="text-center mt-4">
                      <button className="btn btn-success btn-lg px-5" onClick={() => peticionPost()}>
                        🚀 Crear Campana de Video
                      </button>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Sidebar>
          </div>
        </div>
      );
    }
    else {
      return (
        <div>
          <Sidebar>
            <SinPermisos />
          </Sidebar>
        </div>
      );
    }
  }
  else {
    return (
      <div>
        <Sidebar>
          <SinPermisos />
        </Sidebar>
      </div>
    );
  }
};

export default Referidos;